import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import { setBacklogCardGroupSettings } from '../../services/local-storage';
import {
	CARD_GROUP_TOGGLE,
	COLLAPSE_ALL_CARD_GROUPS,
	SET_EXPANDED_CARD_GROUP,
} from '../../state/actions/card-list';
import { getRapidViewId } from '../../state/selectors/app';
import { getExpandedCardGroups } from '../../state/selectors/cards';
import type { MiddlewareAPI, ActionsObservable } from '../../state/types';

export const cardGroupToggleEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$
		.ofType(CARD_GROUP_TOGGLE, COLLAPSE_ALL_CARD_GROUPS, SET_EXPANDED_CARD_GROUP)
		.flatMap(() => {
			const state = store.getState();
			const expandedCardGroups = getExpandedCardGroups(state);
			setBacklogCardGroupSettings(Number(getRapidViewId(state)), expandedCardGroups);
			return Observable.empty<never>();
		});
